import {
  DisclosureOperation,
  GenerateDisclosureRequest,
  GenerateDisclosureResponse,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const GENERATE_DISCLOSURE_URI = `/api/disclosure/payment-agreement`;

interface GenerateDisclosureHandlerParams {
  paymentAgreementID: string;
  disclosureOperation: DisclosureOperation;
  paymentMethodID?: string;
  apiFetch: APIFetch;
}

export async function generateDisclosures({
  paymentAgreementID,
  disclosureOperation,
  paymentMethodID,
  apiFetch,
}: GenerateDisclosureHandlerParams): Promise<
  HandlerResponse<GenerateDisclosureResponse>
> {
  const res: APIResponse<GenerateDisclosureResponse> = await apiFetch<
    GenerateDisclosureResponse,
    GenerateDisclosureRequest
  >(
    `${GENERATE_DISCLOSURE_URI}/${paymentAgreementID}`,
    {
      body: {
        disclosureOperation,
        paymentMethodID,
      },
    },
    GenerateDisclosureResponse
  );

  return handleResponse(res);
}
